import axios from "axios";
import { clear, get, set } from "./cookies";

import store from "../store";
import React from "react";
import { logOut } from "../modules/authentication/store/reducer";
import { clearLocal } from "./localStorage";
const API_URL = import.meta.env.VITE_API_URL;
class Axios {
  constructor(baseURL) {
    this.axios = axios.create({
      baseURL,
    });
    this.axios.interceptors.request.use(this.requestMiddleware);
    this.axios.interceptors.response.use(
      this.responseMiddleware,
      this.responseErrorMiddleware,
    );
  }

  requestMiddleware = (request) => {
    const token = get("token");
    if (token) {
      request.headers.authorization = token.startsWith("Bearer ")
        ? token
        : "Bearer " + token;
    }
    const browserModel = this.detectBrowser();
    const osVersion = this.detectOSVersion();
    request.headers["X-Device-Id"] = "device-admin-123";

    request.headers["platform"] = 1;
    request.headers["version"] = React.version;
    request.headers["model"] = browserModel;
    request.headers["os"] = osVersion;
    request.headers["Content-Type"] = "application/json";
    return request;
  };

  responseMiddleware = (response) => {
    const token = get("token");
    if (response?.data?.token) {
      if (token) {
        set("token", response.data.token);
      }
    }
    return response;
  };
  detectOSVersion = () => {
    const userAgent = window.navigator.userAgent;
    let osVersion = "Unknown";

    if (userAgent.includes("Windows NT")) {
      // Windows
      const windowsVersion = /Windows NT (\d+\.\d+)/.exec(userAgent);
      osVersion = windowsVersion ? windowsVersion[1] : "Unknown";
    } else if (userAgent.includes("Mac OS X")) {
      // macOS
      const macVersion = /Mac OS X (\d+_\d+)/.exec(userAgent);
      osVersion = macVersion ? macVersion[1].replace("_", ".") : "Unknown";
    } else if (userAgent.includes("Linux")) {
      // Linux
      const linuxVersion = /Linux/.exec(userAgent);
      osVersion = linuxVersion ? "Linux" : "Unknown";
    }

    return osVersion;
  };
  detectBrowser = () => {
    const userAgent = window.navigator.userAgent;

    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Chrome")) {
      return "Google Chrome";
    } else if (userAgent.includes("Safari")) {
      return "Safari";
    } else if (userAgent.includes("Edge")) {
      return "Edge";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
      return "Internet Explorer";
    } else {
      return "Unknown";
    }
  };
  responseErrorMiddleware = (error) => {
    if (
      (error?.response?.data?.message || "").toLowerCase() ===
      "permission reverted"
    ) {
      window.location.replace("/");
    }
    if (error?.response?.status === 401 || error?.response?.status === 503) {
      clear();
      clearLocal();
      // store.dispatch(logOut())
      return false;
    }
    return Promise.reject(error);
  };
}

const axiosApi = new Axios(API_URL).axios;

export { axiosApi };
